import DropMultiSelectFilter from './DropMultiSelectFilter.vue';
export default DropMultiSelectFilter;